export default __webpack_public_path__ + "static/media/motorcycle-dealer1.2cba474e.png";